// extracted by mini-css-extract-plugin
export var badgeTextContainer = "_9-2";
export var blackBorderOnHover = "_9-7";
export var cell = "_9-6";
export var cellContainer = "_9-3";
export var checked = "_9-8";
export var disabled = "_9-5";
export var featuredIconCellContainer = "_9-9";
export var featuredIconTextContainer = "_9-b";
export var featuredIconWrapper = "_9-a";
export var noBorder = "_9-c";
export var orangeSelectedRow = "_i-3";
export var overflowableText = "_9-0";
export var overflowableTextContainer = "_9-1";
export var row = "_a-0";
export var rowCheckboxCell = "_9-4";
export var selectableTable = "_i-2";